import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { addCoins, addLoyalty } from '../../../state/actions/extras';
import { addXp } from '../../../state/slices/xp/xp';
import store from '../../../state/store';
import { MISSIONS_REWARD_BUNDLE_TYPE } from '../constants';
var rewardTypeCoins = function rewardTypeCoins(rewardItems) {
  return store.dispatch(addCoins(rewardItems[0].rewardValue));
};
var rewardTypeLoyalty = function rewardTypeLoyalty(rewardItems) {
  return store.dispatch(addLoyalty(rewardItems[0].rewardValue));
};
var rewardTypeCoinsAndXPPoints = function rewardTypeCoinsAndXPPoints(rewardItems) {
  store.dispatch(addCoins(rewardItems[0].rewardValue));
  store.dispatch(addXp(rewardItems[1].rewardValue));
};
var handlerRewardsClaim = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  default: function _default() {
    return null;
  }
}, MISSIONS_REWARD_BUNDLE_TYPE.COINS, rewardTypeCoins), MISSIONS_REWARD_BUNDLE_TYPE.LOYALTY_POINTS, rewardTypeLoyalty), MISSIONS_REWARD_BUNDLE_TYPE.COINS_AND_XP_POINTS, rewardTypeCoinsAndXPPoints), MISSIONS_REWARD_BUNDLE_TYPE.XP_MULTIPLIER, function () {
  return null;
}), MISSIONS_REWARD_BUNDLE_TYPE.TIMED_BONUS_MULTIPLIER, function () {
  return null;
});
var missionsRewardsClaim = function missionsRewardsClaim(_ref) {
  var rewardBundleType = _ref.rewardBundleType,
    rewardItems = _ref.rewardItems;
  if (rewardBundleType === MISSIONS_REWARD_BUNDLE_TYPE.MYSTERY_GIFT) {
    var handlerFunction = handlerRewardsClaim[rewardItems[0].rewardValue.rewardBundleType];
    if (handlerFunction) handlerFunction(rewardItems[0].rewardValue.rewardItems);else handlerRewardsClaim['default']();
  } else {
    var _handlerFunction = handlerRewardsClaim[rewardBundleType];
    if (_handlerFunction) _handlerFunction(rewardItems);else handlerRewardsClaim['default']();
  }
};
export default missionsRewardsClaim;